import iconArrowRight from 'icons/icon-arrow-right.svg';
import isIE11 from 'utils/isIE11';

const styles = ({ links }) => ({
  background: isIE11 ? `transparent url(${iconArrowRight}) 0 50% no-repeat` : links.link.color,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100%',
  bottom: -2,
  display: 'inline-block',
  height: 15,
  maskImage: isIE11 ? 'none' : `url(${iconArrowRight})`,
  position: 'relative',
  width: 16,
});

export default styles;
